import { api } from '../api/client';
import type {
  AssistantPairingResponse,
  AssistantSettingsRequest,
  AssistantStatusResponse,
} from '@familyhub/shared';

/**
 * Huub's server state (docs/ASSISTENT.md §11). Online-only, like the recipe
 * settings: nothing here is in Dexie, because the state lives with the worker
 * that holds the Signal link.
 */
export const getAssistant = () => api<AssistantStatusResponse>('/api/v1/assistant');

export const requestPairingCode = () =>
  api<AssistantPairingResponse>('/api/v1/assistant/pairing-code', { method: 'POST' });

export const unpair = (userId: string) =>
  api<AssistantStatusResponse>(`/api/v1/assistant/members/${userId}`, { method: 'DELETE' });

export const putAssistantSettings = (body: AssistantSettingsRequest) =>
  api<AssistantStatusResponse>('/api/v1/assistant/settings', { method: 'PUT', body });

export const editMemory = (id: string, body: { kind?: 'fact' | 'persona'; text?: string }) =>
  api<AssistantStatusResponse>(`/api/v1/assistant/memories/${id}`, { method: 'PATCH', body });

export const addMemory = (body: { kind: 'fact' | 'persona'; text: string }) =>
  api<AssistantStatusResponse>('/api/v1/assistant/memories', { method: 'POST', body });

export const forget = (id: string) =>
  api<AssistantStatusResponse>(`/api/v1/assistant/memories/${id}`, { method: 'DELETE' });
